module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--fr-1febeac6a83d1b6e4277d08a750fce0b.webp";